import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Star, ChevronLeft, ChevronRight, MessageSquareQuote, ExternalLink } from "lucide-react";

export default function Reviews() {
  const [reviews, setReviews] = useState([]);
  const [contact, setContact] = useState({});
  const [i, setI] = useState(0);

  useEffect(() => {
    api.get("/content/reviews").then((r) => setReviews(r.data)).catch(() => {});
    api.get("/content/contact").then((r) => setContact(r.data || {})).catch(() => {});
  }, []);

  const has = reviews.length > 0;
  const cur = has ? reviews[i % reviews.length] : null;
  const prev = () => setI((v) => (v - 1 + reviews.length) % reviews.length);
  const next = () => setI((v) => (v + 1) % reviews.length);

  return (
    <section className="py-16 sm:py-24 bg-offwhite" data-testid="reviews-section">
      <div className="mx-auto max-w-4xl px-4 sm:px-6">
        <div className="text-center">
          <span className="text-sm font-semibold uppercase tracking-widest text-electric">Anmeldelser</span>
          <h2 className="mt-2 font-heading text-3xl sm:text-4xl font-bold text-navy">Det kundene sier</h2>
        </div>

        <div className="mt-10">
          {has ? (
            <div className="relative rounded-2xl border border-hairline bg-white p-8 sm:p-10 shadow-sm text-center" data-testid="review-card">
              <MessageSquareQuote className="mx-auto h-8 w-8 text-electric/30" />
              <div className="mt-3 flex justify-center gap-1">
                {Array.from({ length: 5 }).map((_, k) => (
                  <Star key={k} className={`h-5 w-5 ${k < cur.rating ? "fill-warm text-warm" : "text-slate-200"}`} />
                ))}
              </div>
              <p className="mt-4 text-lg leading-relaxed text-ink/80">“{cur.text}”</p>
              <p className="mt-4 font-heading text-base font-bold text-navy">{cur.author}</p>
              {reviews.length > 1 && (
                <div className="mt-6 flex items-center justify-center gap-3">
                  <button onClick={prev} className="flex h-10 w-10 items-center justify-center rounded-full border border-hairline bg-white hover:border-electric" data-testid="review-prev"><ChevronLeft className="h-5 w-5 text-navy" /></button>
                  <span className="text-sm text-ink/50">{(i % reviews.length) + 1} / {reviews.length}</span>
                  <button onClick={next} className="flex h-10 w-10 items-center justify-center rounded-full border border-hairline bg-white hover:border-electric" data-testid="review-next"><ChevronRight className="h-5 w-5 text-navy" /></button>
                </div>
              )}
            </div>
          ) : (
            <div className="rounded-2xl border border-dashed border-hairline bg-white p-10 text-center" data-testid="reviews-empty">
              <MessageSquareQuote className="mx-auto h-10 w-10 text-slate-300" />
              <p className="mt-4 font-heading text-lg font-bold text-navy">Ingen anmeldelser ennå</p>
              <p className="mt-2 text-sm text-ink/60">Bli den første til å dele din opplevelse med MobilHub.</p>
            </div>
          )}

          {contact.maps_link && (
            <div className="mt-6 text-center">
              <a
                href={contact.maps_link}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 rounded-full border border-hairline bg-white px-6 py-3 text-sm font-semibold text-navy hover:border-electric transition-colors"
                data-testid="google-maps-button"
              >
                Se møtestedet i Google Maps <ExternalLink className="h-4 w-4 text-electric" />
              </a>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
